import { Callout } from "@wayflyer/flyui";
import type { ConnectorPropertiesSchema } from "shared-ui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../connection-manager-next/message-definitions";

import { getMarketingBannerState } from "./marketing-banner-state";

export const MarketingStatusBanner = ({ connectors }: { connectors: ConnectorPropertiesSchema[] }) => {
  const intl = useIntl();
  const state = getMarketingBannerState(connectors);

  if (!state) {
    return null;
  }

  const description =
    state.messageKey === "singlePlatform"
      ? intl.formatMessage(MESSAGES.marketingBannerSinglePlatform, { platformName: state.platformName })
      : intl.formatMessage(MESSAGES.marketingBannerMultiplePlatforms, {
          platformNames: new Intl.ListFormat(intl.locale, { style: "long", type: "conjunction" }).format(
            state.platformNames
          ),
          count: state.count,
        });

  return <Callout variant="info" description={description} />;
};
